import { getEnvironmentVariablesValue } from "@utility/environmentVariables";
import translateToLocale from "@utility/translateToLocale";

export const SSO_SIGNUP_KEY = "@lum-s_s_o-signup@";
export const LOGO_URL = "/lumenore-icons/svg/lumenore-logo-dark.svg";
export const HELP_URL = "mailto:connect@lumenore.com";
export const DESCRIPTION = translateToLocale("platformLayout.copyright", "© ${year}, ${companyName}. All rights reserved.", {
    year: new Date().getFullYear(),
    companyName: translateToLocale("whiteLabelling.companyName", "Lumenore", { returnStringValueOnly: true }),
    returnStringValueOnly: true,
});
export const RECAPTCHA_SECRET = getEnvironmentVariablesValue("RECAPTCHA_SITE_KEY") || "6LcbPMgUAAAAAO8j2Z0MA2KzU2BanHcTCBfwxKG_";

// security headers constants
export const FORGOT_PASSWORD_SECURITY_KEY_ONE = getEnvironmentVariablesValue("FORGOT_PASSWORD_SECURITY_KEY_ONE") || "de513cc89289fa2be8a6ee6fdb6a9671b26a6db9"
export const FORGOT_PASSWORD_SECURITY_KEY_TWO = getEnvironmentVariablesValue("FORGOT_PASSWORD_SECURITY_KEY_TWO") || "fdb6a9671b26a6db9de513cc89289fa2be8a6ee6"
export const FORGOT_PASSWORD_SECURITY_KEY_THREE = getEnvironmentVariablesValue("FORGOT_PASSWORD_SECURITY_KEY_THREE") || "defa2be8a6ee6fdb6a9671b26a6db9513cc8928943"

export const SIGNUP_FLOW_SECURITY_KEY_ONE = getEnvironmentVariablesValue("SIGNUP_FLOW_SECURITY_KEY_ONE") || "dbciyegc238r3uge833yeic1c"
export const SIGNUP_FLOW_SECURITY_KEY_TWO = getEnvironmentVariablesValue("SIGNUP_FLOW_SECURITY_KEY_TWO") || "dbciyegc23ddduge833yeicc2"
export const SIGNUP_FLOW_SECURITY_KEY_THREE = getEnvironmentVariablesValue("SIGNUP_FLOW_SECURITY_KEY_THREE") || "dbciyegc23ddduge833yei3cc"
export const SIGNUP_FLOW_SECURITY_KEY_FOUR = getEnvironmentVariablesValue("SIGNUP_FLOW_SECURITY_KEY_FOUR") || "dbciyegc23ddduge833yeic4c"

export const SECURITY_HEADERS_LOGIN_TOKEN = getEnvironmentVariablesValue("SECURITY_HEADERS_LOGIN_TOKEN") || "ldo5g3ci89n89fa2be8a6ee6fdb6a9671b"
export const SECURITY_HEADERS_VERIFIED_TOKEN = getEnvironmentVariablesValue("SECURITY_HEADERS_VERIFIED_TOKEN") || "de513cc89289fa2be8a6ee6fdb6a9671b26a6db9"

export const SECURITY_HEADERS_VALIDATE_PASSWORD_TOKEN_ONE = getEnvironmentVariablesValue("SECURITY_HEADERS_VALIDATE_PASSWORD_TOKEN_ONE") || "f30c466b4e26587c6788060d436b0a29"
export const SECURITY_HEADERS_VALIDATE_PASSWORD_TOKEN_TWO = getEnvironmentVariablesValue("SECURITY_HEADERS_VALIDATE_PASSWORD_TOKEN_TWO") || "b72d1f93a4d6581e6f5b3d9801a6c74d"

export const X_SSO_TOKEN_HEADER = "x-sso-token"


